/* eslint-disable */
import createIcon from '../createIcon';

const IconVerticalAlignTopOutlined = createIcon({
  name: 'icon-vertical-align-top-outlined',
  content: '<path d="M821.376 330.624h-640v-64h640v64z m-3.52 381.056l-45.696 45.696-271.36-271.36-271.296 271.36-45.632-45.696 316.8-316.736 0.128 0.192 0.256-0.192 316.8 316.8z"/>',
  width: 1024,
  height: 1024
}, 'Icon');
export default IconVerticalAlignTopOutlined;
